module.exports = __webpack_public_path__ + "img/media-line-top.3a5f807f.svg";